import OutlinedTabs from './OutlinedTabs';
import './OutlinedTabs.scss';

export default OutlinedTabs;